import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Box,
  IconButton,
  MenuItem,
  Menu,
  TextField,
  Grid,
  useMediaQuery,
  useTheme,
  FormControl,
  Select,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDataContext } from "../../context/Context";
import { Link } from "react-router-dom";
// import "./styles.css";

const columns = (handleClick, handleClose, anchorEl, open) => [
  {
    field: "updatedAt",
    headerName: "DATE",
    flex: 1,
    renderCell: (params) => (
      <span style={{}}>
        {/* {params.row.updatedAt} */}
        {new Date(params.row.updatedAt).toLocaleString()}
      </span>
    ),
  },
  {
    field: "invoiceNumber",
    headerName: "BILL NO.",
    flex: 1,
    renderCell: (params) => (
      <Link to={`/purchase/view/${params.row._id}`} style={{}}>
        <span>BILL#{params.row.invoiceNumber}</span>
      </Link>
    ),
  },
  {
    field: "customer",
    headerName: "VENDOR NAME",
    flex: 1,
    valueGetter: (params) => params?.name || "N/A",
  },
  {
    field: "items",
    headerName: "ITEM COUNT",
    flex: 1,
    valueGetter: (params) => params?.length || "N/A",
  },
  {
    field: "total",
    headerName: "AMOUNT",
    flex: 1,
    valueGetter: (params) => params + " AED" || "N/A",
  },
  {
    field: "balance",
    headerName: "BALANCE",
    flex: 1,
    valueGetter: (params) => "0 AED" || "N/A",
  },
  { field: "dueDate", headerName: "DUE DATE", flex: 1 },
  {
    field: "status",
    headerName: "STATUS",
    flex: 1,
    renderCell: (params) => (
      <span
        style={{
          background: "pink",
          padding: 5,
          paddingLeft: 15,
          paddingRight: 15,
          borderRadius: 10,
        }}
      >
        Paid
      </span>
    ),
  },
  {
    field: "actions",
    headerName: "ACTIONS",
    sortable: false,
    width: 200,
    renderCell: (params) => (
      <strong>
        <IconButton color="grey" aria-label="edit">
          <EditIcon sx={{ fontSize: "20px" }} />
        </IconButton>
        <IconButton color="grey" aria-label="delete">
          <DeleteIcon sx={{ fontSize: "20px" }} />
        </IconButton>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={(event) => handleClick(event, params.row.id)}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose} startIcon={<VisibilityIcon />}>
            View
          </MenuItem>
          <MenuItem onClick={handleClose} startIcon={<EditIcon />}>
            Edit
          </MenuItem>
          <MenuItem onClick={handleClose} startIcon={<DeleteIcon />}>
            Delete
          </MenuItem>
        </Menu>
      </strong>
    ),
  },
];

function InvoiceList() {
  const { purc: rows } = useDataContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]); // State to track selected rows
  const [searchQuery, setSearchQuery] = useState(""); // New state for search query
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(id);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };
  const handleSelectionChange = (selectionModel) => {
    setSelectedRows(selectionModel); // Update the state with selected row IDs
    console.log("SELECTEDROW", selectedRows);
  };
  const handleCreatePurchase = () => {
    console.log("Selected rows for purchase:", selectedRows);
  };
  const filteredRows = rows
    .filter(
      (row) =>
        String(row.invoiceNumber)
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) || // Convert invoiceNumber to string and perform case-insensitive match
        row.customer?.name?.toLowerCase().includes(searchQuery.toLowerCase()) || // Case-insensitive match for customer name
        String(row.total).includes(searchQuery) // Match on total if needed
    )
    .sort((a, b) => {
      const dateA = new Date(a.createdAt); // Convert the ISO date string to a Date object
      const dateB = new Date(b.createdAt);
      return dateB - dateA; // Sort from earliest to latest
    });
  return (
    <Box
      style={{
        padding: 20,
      }}
      className="purchaselist"
    >
      <div style={{ padding: 0 }}>
        <div className="manageaudit" style={{}}>
          <ul style={{ padding: 0, margin: 0 }}>
            <li style={{}}>
              <div
                className="searchBox"
                style={{ display: "flex", alignItems: "center" }}
              >
                <TextField
                  style={{ marginRight: "8px" }}
                  placeholder="Search"
                  variant="outlined"
                  InputProps={{
                    style: { height: "46px" }, // Adjust height to match Select
                  }}
                  value={searchQuery} // Set value of TextField
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <FormControl sx={{ m: 1, width: "40%" }}>
                  <Select
                    style={{ height: 46 }}
                    name="salutation"
                    value="All Banks"
                  >
                    <MenuItem value="All Banks">All Banks</MenuItem>
                    <MenuItem value="Ms">Ms</MenuItem>
                    <MenuItem value="Mrs">Mrs</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </li>
            <li>
              <div
                className="searchBox"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Link to="/purchases/add">
                  <Button
                    variant="contained"
                    startIcon={<AddCircleOutlineIcon />}
                    sx={{
                      marginLeft: isSmallScreen ? 0 : 2,
                      mt: isSmallScreen ? 2 : 0,
                      height: "50px",
                      width: isSmallScreen ? "100%" : "auto",
                      backgroundColor: "#0597b1",
                    }}
                    className="buttoncolor"
                  >
                    Add Purchase
                  </Button>
                </Link>
              </div>
            </li>
            <li align="right" style={{ marginTop: "16px" }}>
              <div
                className="nawdashLabel"
                style={{
                  paddingTop: "2px",
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  style={{
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: " #e4b7b7",
                    color: "#a01c1c",
                  }}
                >
                  PDF
                </Button>
                <Button
                  variant="outlined"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#d1ddf7",
                    color: "#093240",
                    border: "none",
                  }}
                >
                  PRINT
                </Button>
                <Button
                  variant="outlined"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#c6f6d1",
                    color: " #0a6323",
                    border: "none",
                  }}
                >
                  CSV
                </Button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <Box
        sx={{
          width: "100%",
          // marginTop: 4,
          // p: isSmallScreen ? 2 : 3,
          background: "white",
          // boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
          borderRadius: 1,
        }}
      >
        <DataGrid
          rows={filteredRows} // Use filtered rows
          columns={columns(handleClick, handleClose, anchorEl, open)}
          // pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          paginationMode="client"
          rowCount={filteredRows.length}
          checkboxSelection
          disableSelectionOnClick
          getRowId={(row) => row._id}
          onRowSelectionModelChange={(newSelectionModel) =>
            handleSelectionChange(newSelectionModel)
          }
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          sx={{
            marginTop: 2,
            border: "none",
            "& .MuiDataGrid-cell": {
              border: "none",
            },
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
            },
            "& .MuiDataGrid-toolbarContainer": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "grey",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: "black",
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default InvoiceList;
